"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    clipboardResult: "Clipboard Result",
    thisHasBeenCopied: "Copied to your clipboard!",
};
